module.exports = __webpack_public_path__ + "static/media/bg-mob-1.21812f32.jpg";